import { render, staticRenderFns } from "./companyInfoWindow.vue?vue&type=template&id=08c72cb2&scoped=true"
import script from "./companyInfoWindow.vue?vue&type=script&lang=js"
export * from "./companyInfoWindow.vue?vue&type=script&lang=js"
import style0 from "./companyInfoWindow.vue?vue&type=style&index=0&id=08c72cb2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08c72cb2",
  null
  
)

export default component.exports